document.addEventListener('DOMContentLoaded', function() {
  var hc_swatches = document.querySelectorAll('.hc-swatch');
  hc_swatches.forEach(function(hc_swatch) {
  hc_swatch.addEventListener('click', function() {
      const hc_price = hc_swatch.getAttribute('data-price');
      const hc_compare_price = hc_swatch.getAttribute('data-compare-price');
      const hc_product = hc_swatch.getAttribute('data-product');
      const hc_variant = hc_swatch.getAttribute('data-variant');
      
      if(document.querySelector('.hc-price[data-product="'+hc_product+'"]')){
       document.querySelector('.hc-price[data-product="'+hc_product+'"]').innerText = hc_price;
      }

      if(document.querySelector('.hc-options[data-product="'+hc_product+'"]')){
        const hcNonColorIndex = document.querySelector('.hc-options[data-product="'+hc_product+'"]').selectedOptions[0].getAttribute('data-index');
        const hcNonColorText = document.querySelector('.hc-options[data-product="'+hc_product+'"]').selectedOptions[0].getAttribute('data-value');
        const hcColor = hc_swatch.getAttribute('data-value');
        const hcColorIndex = hc_swatch.getAttribute('data-index');

        const hcNonColorDisabled = document.querySelectorAll('.hc-options[data-product="'+hc_product+'"] option');
        hcNonColorDisabled.forEach(function(hc_option){
          hc_option.classList.add('hc-disabled');
        });
        
        const hcNonColorEnabled = document.querySelectorAll('.hc-options[data-product="'+hc_product+'"] option[data-color="'+hcColor+'"]');
        hcNonColorEnabled.forEach(function(hc_option){
          hc_option.classList.remove('hc-disabled');
        });

        if(document.querySelector('.hc-variant[data-product="'+hc_product+'"][data-value-'+hcColorIndex+'="'+hcColor+'"][data-value-'+hcNonColorIndex+'="'+hcNonColorText+'"]')){
          const hcVariant = document.querySelector('.hc-variant[data-product="'+hc_product+'"][data-value-'+hcColorIndex+'="'+hcColor+'"][data-value-'+hcNonColorIndex+'="'+hcNonColorText+'"]').getAttribute('data-variant');           
          document.querySelector('.hc-input[data-product="'+hc_product+'"]').setAttribute('value', hcVariant);
          document.querySelector('.hc-trigger[data-product="'+hc_product+'"]').setAttribute('data-variant', hcVariant);
        }
      }else{
         document.querySelector('.hc-input[data-product="'+hc_product+'"]').setAttribute('value', hc_variant);
      }   

     if(document.querySelector('.hc-compare-price[data-product="'+hc_product+'"]')){
      document.querySelector('.hc-compare-price[data-product="'+hc_product+'"]').innerText = hc_compare_price;
     }
   });
  });

  const hc_buttons = document.querySelectorAll('.hc-trigger');
  hc_buttons.forEach(hc_button => {

    hc_button.addEventListener('click', function(e) {
      e.preventDefault();
      let hc_product = parseInt(this.getAttribute('data-product'));
      
      let addToCartForm = document.querySelector('.hc-collection-form[data-product="'+hc_product+'"]');
      let formData = new FormData(addToCartForm);

       fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => {
          return response.json();
        })
        .then(cart => {
          document.dispatchEvent(new CustomEvent("variant:add", {
            bubbles: true,
            detail: {
              cart: cart
            }
          }));
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              cart: cart
            }
          }));
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    });
  });

  /* HC - Dropdowns added - 22 Apr '24 */ 
  const hcSelects = document.querySelectorAll('.hc-options');
  hcSelects.forEach(function(hc_select) {
    hc_select.addEventListener('change', function(e) {
      const selectedValue = e.target.value;   
      const hcProduct = e.target.getAttribute('data-product');
      const hcNonColorIndex = this.selectedOptions[0].getAttribute('data-index');
      const hcNonColorText = this.selectedOptions[0].getAttribute('data-value');

      if(document.querySelector('.product-card__swatch-list input[data-product="'+hcProduct+'"]:checked')){
        const hcColor = document.querySelector('.product-card__swatch-list input[data-product="'+hcProduct+'"]:checked').getAttribute('value');
        const hcColorIndex = document.querySelector('.product-card__swatch-list input:checked[data-product="'+hcProduct+'"]').getAttribute('data-index');
        const hcVariant = document.querySelector('.hc-variant[data-product="'+hcProduct+'"][data-value-'+hcColorIndex+'="'+hcColor+'"][data-value-'+hcNonColorIndex+'="'+hcNonColorText+'"]').getAttribute('data-variant');

        document.querySelector('.hc-input[data-product="'+hcProduct+'"]').setAttribute('value', hcVariant);
        document.querySelector('.hc-trigger[data-product="'+hcProduct+'"]').setAttribute('data-variant', hcVariant);
      }else{
        document.querySelector('.hc-input[data-product="'+hcProduct+'"]').setAttribute('value', selectedValue);
        document.querySelector('.hc-trigger[data-product="'+hcProduct+'"]').setAttribute('data-variant', selectedValue);
      }    
    });  
  });
  
});

document.addEventListener("hcRecommendations", e => {

  var hc_swatches = document.querySelectorAll('.hc-swatch');
  hc_swatches.forEach(function(hc_swatch) {
    hc_swatch.addEventListener('click', function() {
      const hc_price = hc_swatch.getAttribute('data-price');
      const hc_compare_price = hc_swatch.getAttribute('data-compare-price');
      const hc_product = hc_swatch.getAttribute('data-product');
      const hc_variant = hc_swatch.getAttribute('data-variant');
      
      if(document.querySelector('.hc-price[data-product="'+hc_product+'"]')){
       document.querySelector('.hc-price[data-product="'+hc_product+'"]').innerText = hc_price;
      }
  
      if(document.querySelector('.hc-options[data-product="'+hc_product+'"]')){
        const hcNonColorIndex = document.querySelector('.hc-options[data-product="'+hc_product+'"]').selectedOptions[0].getAttribute('data-index');
        const hcNonColorText = document.querySelector('.hc-options[data-product="'+hc_product+'"]').selectedOptions[0].getAttribute('data-value');
        const hcColor = hc_swatch.getAttribute('data-value');
        const hcColorIndex = hc_swatch.getAttribute('data-index');
  
        const hcNonColorDisabled = document.querySelectorAll('.hc-options[data-product="'+hc_product+'"] option');
        hcNonColorDisabled.forEach(function(hc_option){
          hc_option.classList.add('hc-disabled');
        });
        
        const hcNonColorEnabled = document.querySelectorAll('.hc-options[data-product="'+hc_product+'"] option[data-color="'+hcColor+'"]');
        hcNonColorEnabled.forEach(function(hc_option){
          hc_option.classList.remove('hc-disabled');
        });
  
        if(document.querySelector('.hc-variant[data-product="'+hc_product+'"][data-value-'+hcColorIndex+'="'+hcColor+'"][data-value-'+hcNonColorIndex+'="'+hcNonColorText+'"]')){
          const hcVariant = document.querySelector('.hc-variant[data-product="'+hc_product+'"][data-value-'+hcColorIndex+'="'+hcColor+'"][data-value-'+hcNonColorIndex+'="'+hcNonColorText+'"]').getAttribute('data-variant');           
          document.querySelector('.hc-input[data-product="'+hc_product+'"]').setAttribute('value', hcVariant);
          document.querySelector('.hc-trigger[data-product="'+hc_product+'"]').setAttribute('data-variant', hcVariant);
        }
      }else{
         document.querySelector('.hc-input[data-product="'+hc_product+'"]').setAttribute('value', hc_variant);
      }   
  
     if(document.querySelector('.hc-compare-price[data-product="'+hc_product+'"]')){
      document.querySelector('.hc-compare-price[data-product="'+hc_product+'"]').innerText = hc_compare_price;
     }
   });
});
  
  const hc_buttons = document.querySelectorAll('.hc-trigger');
  hc_buttons.forEach(hc_button => {

    hc_button.addEventListener('click', function(e) {
      e.preventDefault();
      let hc_product = parseInt(this.getAttribute('data-product'));
      
      let addToCartForm = document.querySelector('.hc-collection-form[data-product="'+hc_product+'"]');
      let formData = new FormData(addToCartForm);

       fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => {
          return response.json();
        })
        .then(cart => {
          document.dispatchEvent(new CustomEvent("variant:add", {
            bubbles: true,
            detail: {
              cart: cart
            }
          }));
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              cart: cart
            }
          }));
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    });
  });

  /* HC - Dropdowns added - 22 Apr '24 */ 
  const hcSelects = document.querySelectorAll('.hc-options');
  hcSelects.forEach(function(hc_select) {
    hc_select.addEventListener('change', function(e) {
      const selectedValue = e.target.value;   
      const hcProduct = e.target.getAttribute('data-product');
      const hcNonColorIndex = this.selectedOptions[0].getAttribute('data-index');
      const hcNonColorText = this.selectedOptions[0].getAttribute('data-value');

      if(document.querySelector('.product-card__swatch-list input[data-product="'+hcProduct+'"]:checked')){
        const hcColor = document.querySelector('.product-card__swatch-list input[data-product="'+hcProduct+'"]:checked').getAttribute('value');
        const hcColorIndex = document.querySelector('.product-card__swatch-list input:checked[data-product="'+hcProduct+'"]').getAttribute('data-index');
        const hcVariant = document.querySelector('.hc-variant[data-product="'+hcProduct+'"][data-value-'+hcColorIndex+'="'+hcColor+'"][data-value-'+hcNonColorIndex+'="'+hcNonColorText+'"]').getAttribute('data-variant');
        document.querySelector('.hc-input[data-product="'+hcProduct+'"]').setAttribute('value', hcVariant);
        document.querySelector('.hc-trigger[data-product="'+hcProduct+'"]').setAttribute('data-variant', hcVariant);
      }else{
        document.querySelector('.hc-input[data-product="'+hcProduct+'"]').setAttribute('value', selectedValue);
        document.querySelector('.hc-trigger[data-product="'+hcProduct+'"]').setAttribute('data-variant', selectedValue);
      }    
    });  
  });
});